/**
 * CE Intent Tracker v1.0
 * Captures visitor product-category intent from metafield-resolved data
 * and fires it to Klaviyo on page view + popup submission.
 *
 * Depends on window.ceIntent being set by Liquid in theme.liquid.
 */
(function () {
  'use strict';

  var intent = window.ceIntent;
  if (!intent) return;

  /* ── A. Normalize collection handles to canonical category slugs ── */
  var COLLECTION_NORMALIZE = {
    'custom-phone-cases': 'phone-cases',
    'custom-photo-blankets': 'blankets',
    'custom-photo-tumblers': 'tumblers',
    'custom-photo-mugs': 'mugs',
    'custom-canvas-prints': 'canvas-prints',
    'custom-posters': 'posters',
    'custom-puzzles': 'puzzles',
    'custom-journals': 'journals',
    'custom-spiral-notebooks': 'notebooks',
    'custom-desk-mats': 'desk-mats',
    'custom-beach-towels': 'beach-towels',
    'custom-photo-clock': 'clocks',
    'custom-candles': 'candles',
    'custom-apple-watch-bands': 'watch-bands'
  };

  var category = intent.category;

  /* Collections resolve from handle — normalize to canonical slug */
  if (intent.pageType === 'collection' && category) {
    category = COLLECTION_NORMALIZE[category] || category;
  }

  /* No category resolved (homepage, utility pages, cart, etc.) — skip tracking */
  if (!category) return;

  /* ── B. UTM capture (first-touch per session) ── */
  var params = new URLSearchParams(window.location.search);
  var utms = {
    utm_source: params.get('utm_source'),
    utm_medium: params.get('utm_medium'),
    utm_campaign: params.get('utm_campaign'),
    utm_content: params.get('utm_content'),
    utm_term: params.get('utm_term')
  };

  if (utms.utm_source && !sessionStorage.getItem('ce_utms_stored')) {
    Object.keys(utms).forEach(function (k) {
      if (utms[k]) localStorage.setItem('ce_' + k, utms[k]);
    });
    sessionStorage.setItem('ce_utms_stored', '1');
  }

  /* ── C. Store intent in localStorage (most-recent category wins) ── */
  localStorage.setItem('ce_intent_category', category);
  localStorage.setItem('ce_intent_landing_url', window.location.pathname);

  /* ── D. Fire "Viewed Category" event (queue-safe) ── */
  var klaviyo = window.klaviyo || [];
  klaviyo.push(['track', 'Viewed Category', {
    ce_category_slug: category,
    page_type: intent.pageType,
    url: window.location.href,
    referrer: document.referrer || null,
    utm_source: utms.utm_source,
    utm_medium: utms.utm_medium,
    utm_campaign: utms.utm_campaign
  }]);

  /* ── E. Klaviyo form submit handler ── */
  window.addEventListener('klaviyoForms', function (e) {
    if (!e.detail || e.detail.type !== 'submit') return;

    var cat = localStorage.getItem('ce_intent_category');
    var landingUrl = localStorage.getItem('ce_intent_landing_url');

    var identifyProps = {};
    if (cat) {
      identifyProps.ce_intent_primary_category = cat;
      identifyProps.ce_intent_primary_category_set_at = new Date().toISOString();
    }
    if (landingUrl) identifyProps.ce_intent_landing_url = landingUrl;

    /* Attach stored UTMs */
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
      var v = localStorage.getItem('ce_' + k);
      if (v) identifyProps['ce_intent_' + k] = v;
    });

    var kl = window.klaviyo || [];
    kl.push(['identify', identifyProps]);
    kl.push(['track', 'Captured Intent', {
      ce_intent_primary_category: cat || 'unknown',
      ce_intent_source: 'popup',
      ce_intent_landing_url: landingUrl || null,
      utm_source: localStorage.getItem('ce_utm_source'),
      utm_medium: localStorage.getItem('ce_utm_medium'),
      utm_campaign: localStorage.getItem('ce_utm_campaign')
    }]);
  });
})();
